import { render } from "./Attachments_Global_Progress_UI.vue?vue&type=template&id=30a9a448"
import script from "./Attachments_Global_Progress_UI.vue?vue&type=script&lang=js"
export * from "./Attachments_Global_Progress_UI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__